import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getInventoryItemIdByPlant } from '../../api/production-request-api/index.js';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to fetch a specific inventory item by its ID.
 * @param {Pella.ProductionRequestAPI.GetInventoryItemIdByPlantInput} input - The input parameters to retrieve the inventory item.
 */
export const useInventoryItem = (input) => {
  const { apiReady } = useApiReady();

  return useQuery({
    queryKey: [QUERY_KEYS.INVENTORY_ITEM, input],
    queryFn: () => getInventoryItemIdByPlant(input),
    enabled: Boolean(apiReady && input?.item && input?.organizationId),
  });
};
